import { Component, OnInit } from '@angular/core';
import {Checklist} from "../../model/Checklist";
import {ErrorChildren} from "../../model/ErrorChildren";
import {FileuploadService} from "../../service/http/fileupload.service";
import {AcceptDeclineDialogComponent} from "../../dialog/accept-decline-dialog/accept-decline-dialog.component";
import {MatDialog, MatSnackBar} from "@angular/material";
import {TranslateService} from "@ngx-translate/core";
import { SuccessMessageToastComponent } from "../../toast/success-message-toast/success-message-toast.component";
import {Router} from "@angular/router";
import {flatMap, map, switchMap} from 'rxjs/operators';
import {interval} from 'rxjs';

export interface Tile {
  color: string;
  cols: number;
  rows: number;
  text: string;
}

@Component({
  selector: 'app-workflow-validation-upload',
  templateUrl: './workflow-validation-upload.component.html',
  styleUrls: ['./workflow-validation-upload.component.css']
})
export class WorkflowValidationUploadComponent implements OnInit {

  constructor(private uploadService: FileuploadService,
              public dialog: MatDialog,
              private translate: TranslateService,
              public snackBar: MatSnackBar,
              private _router: Router) { }

  currentPackageId: any;

  isLoadingResultsMetadata = false;
  isLoadingResultsXml = false;
  isLoadingResultsPdf = false;
  isLoadingResultsImages = false;
  isLoadingResultsAppAssets = false;
  isLoadingResultsDisclaimer = false;
  isLoadingResultsHotspot = false;

  isMetadataValid = false;
  isXmlValid = false;
  isPdfValid = false;
  isImagesValid = false;
  isAppAssetsValid = false;
  isDisclaimerValid = false;
  isHotspotValid = false;

  allChecksValid = false;

  isTransforming = false;

  ngOnInit() {

    this.currentPackageId = sessionStorage.getItem('currentPackageId');
  }

  metadataChecklist: Checklist[] = [
    {
      name: 'Metadata form filled successfully',
      success: true,
      tested: false,
      errorMessage: '',
      errorChildren: []
    }
  ];

  xmlChecklist: Checklist[] = [
    {
      name: 'One XML File provided',
      success: true,
      tested: false,
      errorMessage: '',
      errorChildren: []
    },
    {
      name: 'XML Structure validation (DTD)',
      success: false,
      tested: false,
      errorMessage: '',
      errorChildren: []
    },
    {
      name: 'Test for unique IDs',
      success: true,
      tested: false,
      errorMessage: '',
      errorChildren: []
    },
    {
      name: 'Resolve all cross links',
        success: true,
        tested: false,
        errorMessage: '',
        errorChildren: []
    }
  ];

  pdfChecklist: Checklist[] = [
    {
      name: 'At least one PDF File provided',
      success: true,
      tested: false,
      errorMessage: '',
      errorChildren: []
    }
  ];

  imagesChecklist: Checklist[] = [
    {
      name: 'All images found in the XML were provided',
      success: true,
      tested: false,
      errorMessage: '',
      errorChildren: []
    },
    {
      name: 'Image format check',
      success: false,
      tested: false,
      errorMessage: '',
      errorChildren: []
    }
  ];

  appAssetsChecklist: Checklist[] = [
    {
      name: 'All App Assets provided',
      success: true,
      tested: false,
      errorMessage: '',
      errorChildren: []
    }
  ];

  disclaimerChecklist: Checklist[] = [
    {
      name: 'Disclaimer provided',
      success: true,
      tested: false,
      errorMessage: '',
      errorChildren: []
    }
  ];

  hotspotChecklist: Checklist[] = [
    {
      name: 'Hotspot Images provided',
      success: true,
      tested: false,
      errorMessage: '',
      errorChildren: []
    }
  ];

  validate() {

    this.allChecksValid = false;

    this.isMetadataValid = false;
    this.isXmlValid = false;
    this.isPdfValid = false;
    this.isImagesValid = false;

    this.isLoadingResultsMetadata = true;
    this.uploadService.getMetadataValidation(this.currentPackageId).subscribe(data => {
      this.isLoadingResultsMetadata = false;
      this.isMetadataValid = data[0]["success"];
      this.metadataChecklist = data;
      this.validation();
    });

    this.isLoadingResultsXml = true;
    this.uploadService.getXmlValidation(this.currentPackageId).subscribe(data => {
      this.isLoadingResultsXml = false;

      // if(data[0]["success"] && data[1]["success"] && data[2]["success"] && data[3]["success"]) {
      //   this.isXmlValid = true;
      // }

      // only warning for dtd validation
      if(data[0]["success"] && data[2]["success"] && data[3]["success"]) {
        this.isXmlValid = true;
      }

      this.xmlChecklist = data;
      this.validation();
    });

    this.isLoadingResultsPdf = true;
    this.uploadService.getPdfValidation(this.currentPackageId).subscribe(data => {
      this.isLoadingResultsPdf = false;
      this.isPdfValid = data[0]["success"];
      this.pdfChecklist = data;
      this.validation();
    });

    this.isLoadingResultsImages = true;
    this.uploadService.startImagesValidation(this.currentPackageId).subscribe();
    let interval2Sec = interval(2000).pipe(
      map( () => {
        this.uploadService.isImagesValidationInProcess(this.currentPackageId).subscribe(data => {
            if(data['imageValidationInProcess'] === false) {
              this.uploadService.getImagesValidationResult(this.currentPackageId).subscribe(data => {

                        this.isLoadingResultsImages = false;

                        if (data[0]["success"] && data[1]["success"]) {
                          this.isImagesValid = true;
                        }

                        this.imagesChecklist = data;
                        this.validation();

                        interval2Sec.unsubscribe();
                    });
            }
        });
    })
    ).subscribe();

    this.isLoadingResultsAppAssets = true;
    this.uploadService.getAppAssetsValidation(this.currentPackageId).subscribe(data => {
      this.isLoadingResultsAppAssets = false;
      this.isAppAssetsValid = data[0]["success"];
      this.appAssetsChecklist = data;
      this.validation();
    });

    this.isLoadingResultsDisclaimer = true;
    this.uploadService.getDisclaimerValidation(this.currentPackageId).subscribe(data => {
      this.isLoadingResultsDisclaimer = false;
      this.isDisclaimerValid = data[0]["success"];
      this.disclaimerChecklist = data;
      this.validation();
    });

    this.isLoadingResultsHotspot = true;
    this.uploadService.getHotspotValidation(this.currentPackageId).subscribe(data => {
      this.isLoadingResultsHotspot = false;
      this.isHotspotValid = data[0]["success"];
      this.hotspotChecklist = data;
      this.validation();
    });
  }

  validation() {

    if( this.isMetadataValid &&
      this.isXmlValid &&
      this.isPdfValid &&
      this.isImagesValid &&
      this.isAppAssetsValid &&
      this.isDisclaimerValid
      // &&
      // this.isHotspotValid
    ) {

      this.allChecksValid = true;
    }
  }

  upload() {

    const dialogRef = this.dialog.open(AcceptDeclineDialogComponent, {
      width: '250px',
      data: {
        title: this.translate.instant('DIALOG.SUBMIT_ACCEPT_DECLINE_DIALOG.TITLE'),
        message: this.translate.instant('DIALOG.SUBMIT_ACCEPT_DECLINE_DIALOG.MESSAGE'),
        icon: {
          add: true,
          name: 'error_outline'
        }}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result == true) {
        console.log('start transformation');

        this.isTransforming = true;

        this.uploadService.postSubmittedPackage(null, this.currentPackageId).subscribe(data => {

          this.isTransforming = false;

          let toast = this.snackBar.openFromComponent(SuccessMessageToastComponent, {
            duration: 5000,
            panelClass: ['white-snackbar']
          });

          toast.afterDismissed().subscribe(() => {
            this._router.navigate(['/provided']);
          });

        });
      }
    });
  }
}
